export default __webpack_public_path__ + "static/media/git.b0df2e98.svg";